import { oz } from '@weft/utils';

export const GetBillingCyclePageResponseSchema = oz.object({
  regularBillingCycleInvoicesCount: oz.number(),
  inspectionBillingCycleInvoicesCount: oz.number(),
  oldBillingCycleInvoicesCount: oz.number(),
  overcharges: oz.number(),
}).openapi('GetBillingCyclePageResponse');

export type GetBillingCyclePageResponse = oz.infer<typeof GetBillingCyclePageResponseSchema>;